<template>
  <div id="app">
    <v-app id="inspire" light>
      <v-card color="grey lighten-5" flat>
        <v-layout row wrap>
          <v-flex xs12 sm12>
            <v-toolbar size="120px" dark color="info">
              <v-toolbar-title class="baslikfont">Firma Kredi Kartına Göre Hesap Ekstresi</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-text-field flat="" solo-inverted="" hide-details v-model="search3" label=" Ara" append-icon="search"></v-text-field>

              <v-menu offset-y>
                <v-btn slot="activator" dark icon>
                  <v-icon>more_vert</v-icon>
                </v-btn>
                <v-list>

                  <v-list-tile @click="getListHtml()">
                    <v-list-tile-title>Html İndir</v-list-tile-title>
                  </v-list-tile>


                  <v-list-tile @click="getListExcel()">
                    <v-list-tile-title>Excel İndir</v-list-tile-title>
                  </v-list-tile>

                </v-list>
              </v-menu>
            </v-toolbar>
          </v-flex>



          <v-container fluid="">
            <v-layout row wrap>

              <v-flex xs12 sm6 md6 style="padding-right:2px;">
                <v-card color="#1E88E5" class="white--text">
                  <v-layout>
                    <v-flex xs2 sm2 md2>
                      <v-layout align-center="" justify-center="" fill-height="">
                        <v-icon color="white" large="">add_comment</v-icon>
                      </v-layout>
                    </v-flex>
                    <v-flex xs12 sm10 md10>

                      <v-card-title primary-title="">

                        <v-flex xs12 sm12 md12>
                          <v-layout>
                            <v-flex xs12 sm3 md12>
                              <v-list-tile-title>
                                <span class="subheading font-weight-">
                                  {{ totalCount }}
                                </span>
                              </v-list-tile-title>
                            </v-flex>

                          </v-layout>
                        </v-flex>


                      </v-card-title>

                    </v-flex>
                  </v-layout>
                  <v-divider light></v-divider>
                  <v-card-actions class="pa-3">
                    <span class="subheading font-weight-bold"> Toplam Adet</span>
                    <v-spacer></v-spacer>
                  </v-card-actions>
                </v-card>
              </v-flex>


              <v-flex xs12 sm6 md6 style="padding-right:2px;">
                <v-card color="#1E88E5" class="white--text">
                  <v-layout>
                    <v-flex xs2 sm2 md2>
                      <v-layout align-center="" justify-center="" fill-height="">
                        <v-icon color="white" large="">cached</v-icon>
                      </v-layout>
                    </v-flex>
                    <v-flex xs12 sm10 md10>

                      <v-card-title primary-title="">

                        <v-flex xs12 sm12 md12>
                          <v-layout>
                            <v-flex xs12 sm3 md12>
                              <v-list-tile-title>
                                <span class="subheading font-weight-">
                                  {{ totalAmount }} &#8378;
                                </span>
                              </v-list-tile-title>
                            </v-flex>

                          </v-layout>
                        </v-flex>


                      </v-card-title>

                    </v-flex>
                  </v-layout>
                  <v-divider light></v-divider>
                  <v-card-actions class="pa-3">
                    <span class="subheading font-weight-bold">Toplam Tutar</span>
                    <v-spacer></v-spacer>
                  </v-card-actions>
                </v-card>
              </v-flex>






            </v-layout>


            <v-card color="grey lighten-5" flat>
              <v-form ref="formtarih" v-model="valid" lazy-validation>

                <v-layout row wrap>
                  <v-flex xs12 sm6 md2>
                    <tarihcomp :etiket="'Başlangıç Tarihi'" :detaygizle="false" :rules="[v => !!v || 'Lütfen tarih seçiniz']"
                      v-bind:defaultvalue="'ok'" v-bind:value="date" v-model="date"></tarihcomp>
                  </v-flex>

                  <v-flex xs12 sm6 md2>
                    <tarihcomp :etiket="'Bitiş Tarihi'" :detaygizle="false" :rules="[v => !!v || 'Lütfen tarih seçiniz']"
                      v-bind:defaultvalue="'ok'" v-bind:value="date2" v-model="date2"></tarihcomp>
                  </v-flex>

                  <v-flex>
                    <v-layout>
                      <div v-if="load1">
                        <v-btn color="info" @click="getList()" fab small="" dark>
                          <v-icon>search</v-icon>
                        </v-btn>
                      </div>
                      <v-btn small="" @mouseenter="tooltip = true" @mouseleave="tooltip = false" ref="fab" @click="filtrele()"
                        color="info" fab dark>
                        <v-icon>filter_list</v-icon>
                      </v-btn>
                      <v-tooltip bottom="" :activator="el" v-model="tooltip">
                        <span>Arama Filtresi Ekle</span>
                      </v-tooltip>
                    </v-layout>
                  </v-flex>
                  <v-flex xs12 sm1>
                  </v-flex>

                  <v-dialog v-model="dialogfiltre" scrollable="" persistent="" max-width="450px">
                    <v-card color="grey lighten-5">
                      <v-card-title>Filtre Seçimi</v-card-title>
                      <v-divider></v-divider>
                      <v-card-text>
                        <v-flex pa-1 xs12 sm12 md12>
                          <v-card>
                            <v-card color="grey lighten-5" flat="">
                              <v-card-actions>
                                <v-layout row="" wrap="">
                                  <v-autocomplete clearable="" label="Cari Kodu" append-icon="search" :loading="loading"
                                    :items="statecari" item-text="text" cache-items="" item-value="id" v-model="EkstreHesap.CariKod"
                                    :search-input.sync="searchcari">
                                  </v-autocomplete>
                                  <v-select :items="kredikarti" label="Firma Kredi Kartı No" v-model="EkstreHesap.FirmaKartNo"
                                    item-text="KrediKartNo" clearable item-value="KrediKartNo" max-height="400"></v-select>
                                  <v-autocomplete hide-details="" clearable :items="itemsairlinelist" label="Havayolu Seçimi"
                                    item-text="HavaYoluTitle" v-model="EkstreHesap.HavayoluKodu" item-value="HavaYoluKodu">
                                  </v-autocomplete>
                                </v-layout>
                              </v-card-actions>
                            </v-card>
                          </v-card>
                        </v-flex>

                        <v-flex pa-1 xs12 sm12 md12>
                          <v-card flat="" color="#9E9E9E">
                            <v-card-title>
                              <span class="subheading white--text font-weight-medium "> Seçenekler</span>
                            </v-card-title>
                          </v-card>
                        </v-flex>

                        <v-layout justify-space-between column>

                          <v-checkbox v-model="EkstreHesap.ServisTutar" label="Ekstrede Servis Tutarıda Gözüksün"
                            hide-details=""></v-checkbox>
                          <v-checkbox v-model="EkstreHesap.ReserveTutar" label="'Değişken Alan Toplam Tutarda Gözükmesin"
                            hide-details=""></v-checkbox>
                          <v-checkbox v-model="EkstreHesap.CoperKayit" label="COPER'den girilen kayıtları Gösterme"
                            hide-details=""></v-checkbox>

                          <v-checkbox v-model="EkstreHesap.CariKayit" label="Cari Hareketten Girilen Kayıtları Gösterme"
                            hide-details=""></v-checkbox>
                          <v-checkbox v-model="EkstreHesap.OzetRapor" label="Detay Rapor" hide-details=""></v-checkbox>
                          <v-checkbox v-model="tumsirketler" label="Tüm Şirketler" hide-details=""></v-checkbox>




                        </v-layout>
                      </v-card-text>
                      <v-divider></v-divider>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="blue darken-1" flat @click.native="filtreiptal()">İptal</v-btn>
                        <v-btn color="blue darken-1" flat @click.native="filtrekayit()">Fİltrelerİ Uygula</v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>

                  <v-flex xs12 sm12>
                    <v-card>
                      <v-data-table :headers="headers" :rows-per-page-items=[50,100] :loading="progress" :items="items"
                        item-key="ToplamAdet" :search="search3">

                        <v-progress-linear slot="progress" indeterminate></v-progress-linear>
                        <template slot="items" slot-scope="props">
                          <!-- <tr @click="props.expanded = !props.expanded"> -->

                          <tr item>
                            <td class="text-xs-left">{{ props.item.FirmaKartNo }}</td>
                            <td class="text-xs-left">{{ props.item.ToplamAdet }}</td>
                            <td class="text-xs-right">{{ props.item.ToplamServis | moneyformat }}</td>
                            <td class="text-xs-right">{{ props.item.ToplamTutar | moneyformat }}</td>
                            <v-btn icon class="mx-0" @click="getir(props.item.EkstreBilgi, props.item.FirmaKartNo)">
                              <v-icon color="teal">line_weight</v-icon>
                            </v-btn>
                          </tr>
                        </template>
                        <template slot="expand" slot-scope="props">

                          <v-data-table hide-actions="" :headers="headers2" :items="props.item.List">
                            <template slot="items" slot-scope="props">
                              <tr style=" background-color:#E6EE9C">
                                <td class="text-xs-left">{{ props.item.Current }}</td>
                                <td class="text-xs-left">{{ props.item.Date }}</td>
                              </tr>
                            </template>
                          </v-data-table>
                        </template>

                        <v-alert slot="no-results" :value="true" color="error" icon="warning">
                          Aradığınız "{{ search3 }}" kelimesi ile ilgili herhangi bir kayıt bulunamadı..
                        </v-alert>
                      </v-data-table>
                    </v-card>
                    <v-dialog scrollable="" v-model="dialog" max-width="1000px">
                      <v-card color="grey lighten-2">
                        <v-toolbar size="120px" color="info">
                          <v-toolbar-title class="white--text"> {{secilenkartno}} </v-toolbar-title>
                          <v-spacer></v-spacer>

                        </v-toolbar>
                        <v-card-text>
                          <v-layout row="" wrap="">
                            <div class="flex md12">
                              <v-data-table :headers="headersservis" :loading="progress" :items="detayitems"
                                hide-actions class="elevation-1">
                                <v-progress-linear slot="progress" indeterminate></v-progress-linear>
                                <template slot="items" slot-scope="props">
                                  <tr item>
                                    <td class="text-xs-left">{{ props.item.Tarih | dateformat }}</td>
                                    <td class="text-xs-left">{{ props.item.BiletNo }}</td>
                                    <td class="text-xs-left">{{ props.item.Havayolu }}</td>
                                    <td class="text-xs-left">{{ props.item.Faturano }}</td>
                                    <td class="text-xs-left">{{ props.item.Cari.Kod }}</td>
                                    <td class="text-xs-left">{{ props.item.YolcuAdi }}</td>
                                    <td class="text-xs-left">{{ props.item.Parkur }}</td>
                                    <td class="text-xs-left">{{ props.item.Tutar | moneyformat }}</td>

                                  </tr>
                                </template>
                              </v-data-table>
                            </div>
                          </v-layout>
                        </v-card-text>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn color="primary" flat @click.native="getListDetayHtml()">
                            İndİr
                          </v-btn>
                          <v-btn color="primary" flat @click="dialog = false">
                            Kapat
                          </v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-dialog>
                    <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'"
                      :left="x === 'left'" :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'" v-model="snackbar">
                      {{ text1 }}
                      <v-btn flat color="pink" @click.native="snackbar = false">Kapat</v-btn>
                    </v-snackbar>
                  </v-flex>

                </v-layout>
              </v-form>
            </v-card>
          </v-container>


        </v-layout>
      </v-card>
    </v-app>
  </div>
</template>


<script>
  import auth from '../../../api/auth'
  import helpers from "@/components/app/customcomp/helpers.js"
  import tarihcomp from '../customcomp/tarihim'

  export default {
    data() {
      return {
        search: '',
        valid:true,
        headers: [{
            text: 'Kart Numarası',
            sortable: false,
            value: 'FirmaKartNo'
          },
          {
            text: 'Toplam Adet',
            value: 'ToplamAdet'
          }, {
            text: 'Toplam Servis',
            value: 'ToplamServis',
            align: 'right'
          },

          {
            text: 'Toplam Tutar',
            value: 'ToplamTutar',
            align: 'right'
          }

        ],
        headers2: [{
            text: 'Cari Kodu',
            value: 'Current',
            class: "background-color:#E0E0E0;"
          },
          {
            text: 'Tarih',
            value: 'Date',
            class: "background-color:#E0E0E0;"
          }
        ],


        headersservis: [{
            text: 'Tarih',
            sortable: false,
            value: 'Tarih'
          },
          {
            text: 'Bilet No',
            value: 'BiletNo'
          }, {
            text: 'Hava Yolu Kodu',
            value: 'Havayolu'
          },

          {
            text: 'Fatura No',
            value: 'Faturano'
          },

          {
            text: 'Cari Kodu',
            value: 'Cari.Kod'
          },

          {
            text: 'Yolcu Adı',
            value: 'YolcuAdi'
          },

          {
            text: 'Parkur',
            value: 'Parkur'
          },

          {
            text: 'Tutar',
            value: 'Tutar'
          }
        ],

        EkstreHesap: {
          FirmaKartNo: '',
          BaslangicTarih: '',
          BitisTarih: '',
          CariKod: '',
          HavayoluKodu: '',
          ServisTutar: '',
          ReserveTutar: '',
          CoperKayit: '',
          CariKayit: '',
          SirketKodu: '',
          OzetRapor: false
        },
        tumsirketler: '',
        totalCount: 0,
        totalService: 0,
        totalAmount: 0,
        StartDate: null,
        EndDate: null,
        date: null,
        menu: false,
        modal: false,
        dateFormatted: '',
        date2: null,
        menu2: false,
        dateFormatted2: '',
        modal2: false,
        loading: false,
        items: [],
        load: false,
        load1: true,
        search3: '',
        detayitems: [],
        renk1: 'info',
        dialogfiltre: false,
        hesapkodu: [],
        kredikarti: [],
        statecari: [],
        itemsairlinelist: [],
        searchcari: '',
        progress: false,
        secilenkartno: null,

        dictionary: {
          custom: {

            tarihsec: {
              required: () => 'Lütfen bir tarih seçiniz'
            },
            tarihsec1: {
              required: () => 'Lütfen bir tarih seçiniz'
            },
          }
        },

        dialog: false,
        butondurum: true,
        snackbar: false,
        y: 'top',
        x: 'right',
        mode: '',
        timeout: 6000,
        text1: '',
        tooltip: false,
        el: null,
      }
    },
    beforeMount: beforeMount,
     components: {
      tarihcomp
    },
    mounted() {
      this.$validator.localize('en', this.dictionary)
      this.el = this.$refs.fab.$el

    },
    watch: {
      searchcari(val) {
        val && this.carigetir(val)
      }
    },
    filters: {

      dateformat: function (t) {
        return helpers.dateformat(t);
      },
      moneyformat: function (m) {
        return helpers.moneyformat(m);
      },

      bakiyekontrol: function (m) {
        return helpers.bakiyekontrol(m);
      }

    },
    methods: {
      getir(id, kartno) {
        console.log(kartno)
        this.secilenkartno = kartno
        this.detayitems = id
        this.dialog = true


      },

      getList: getList,
      getListHtml: getListHtml,
      getListDetayHtml: getListDetayHtml,
      getListExcel: getListExcel,

      filtrele: filtrele,
      filtrekayit: filtrekayit,
      filtreiptal: filtreiptal,
      carigetir: carigetir
    }
  }


  function filtrele() {
    this.dialogfiltre = true

    var credentials = JSON.parse(window.localStorage.getItem('credentials'));

    var params3 = {
      CompanyCode: credentials.SirketKodu
    }

    this.$http.post(auth.API_URL + 'api/FirmCard/List', params3, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.kredikarti = response.body
    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Kayıt Bulunamadı'
        this.snackbar = true
      } else {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
      }
    })

  }

  function filtrekayit() {
    this.renk1 = 'orange darken-4'
    this.dialogfiltre = false
  }

  function filtreiptal() {
    this.renk1 = 'info'
    this.dialogfiltre = false

  }

  function carigetir(v) {
    if (v.length >= 0) {
      this.loading = true
      setTimeout(() => {
        this.$http.post(auth.API_URL + 'api/options/CurrentSearch', {
          q: escape(v)
        }, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          this.statecari = response.body
          this.Error = false
        }, (response) => {
          if (response.status === 0) {
            this.text = 'Service Unavailable'
            this.snackbar = true
          } else {
            this.text = 'Service Unavailable'
            this.snackbar = true
          }
        })
        this.loading = false
      }, 500)
    }
  }

  function getList() {


    if (this.$refs.formtarih.validate()) {

      var bastarih = new Date(this.date)
      var bittarih = new Date(this.date2)

      if (bastarih <= bittarih) {
          this.progress = true
          this.load1 = false



          var credentials = JSON.parse(window.localStorage.getItem('credentials'));

          if (this.tumsirketler === true) {
            this.EkstreHesap.SirketKodu = '0'
          } else {
            this.EkstreHesap.SirketKodu = credentials.SirketKodu
          }

          this.EkstreHesap.BaslangicTarih = this.date
          this.EkstreHesap.BitisTarih = this.date2

          var params = this.EkstreHesap

          this.$http.post(auth.API_URL + 'api/Abstract/ListWithFirmCart', params, {
            headers: {
              'Authorization': 'Bearer ' + auth.getAuthHeader()
            }
          }).then((response) => {

            var toplamadet = 0
            var toplamtutar = 0

            if (response.body[0].ToplamAdet != 0) {

              this.items = response.body


              response.body.forEach(element => {
                toplamtutar = toplamtutar + element.ToplamTutar
                toplamadet = toplamadet + element.ToplamAdet
              });



              this.text1 = 'toplam ' + toplamadet + ' kayıt bulundu..'
              this.snackbar = true
              this.totalCount = toplamadet
              this.totalAmount = toplamtutar.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,')

            } else {
              this.items = []
              this.text1 = 'toplam 0 kayıt bulundu..'
              this.snackbar = true
            }

            this.progress = false
            this.load1 = true

          }, (response) => {
            if (response.status === 0) {
              this.text1 = 'Service Unavailable'
              this.snackbar = true
              this.progress = false
              this.load1 = true
            } else {
              this.text1 = 'Service Unavailable'
              this.snackbar = true
              this.progress = false
              this.load1 = true
            }
          })

        } else {
          this.text1 = 'Başlangıç tarihi bitiş tarihinden büyük olamaz...'
          this.snackbar = true
        }
    }
  }

  function getListDetayHtml() {


    var params = {
      BaslangicTarih: this.date,
      BitisTarih: this.date2,
      FirmaKartNo: this.secilenkartno,
      OzetRapor: true
    }


    this.$http
      .post(auth.API_URL + "api/Abstract/ListWithFirmCartHtml", params, {
        headers: {
          Authorization: "Bearer " + auth.getAuthHeader()
        }
      }).then((response) => {
        this.progress = false
        this.load1 = true
        var blob = new Blob([response.data], {
          type: 'application/html'
        });
        var link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = "FirmaKartEkstre.html";
        link.click();
      }, (response) => {
        if (response.status === 0) {
          this.text1 = 'Service Unavailable'
          this.snackbar = true
          this.progress = false
          this.load1 = true
        } else {
          this.text1 = 'Service Unavailable'
          this.snackbar = true
          this.progress = false
          this.load1 = true
        }
      })
  }

  function getListHtml() {

    this.totalCount = 0,
      this.totalService = 0,
      this.totalAmount = 0,

      this.progress = true
    this.load1 = false


    if (this.date == null) {
      this.date = getDateNow()
    }

    if (this.date2 == null) {
      this.date2 = getDateNow()
    }


    var credentials = JSON.parse(window.localStorage.getItem('credentials'));

    if (this.tumsirketler === true) {
      this.EkstreHesap.SirketKodu = '0'
    } else {
      this.EkstreHesap.SirketKodu = credentials.SirketKodu
    }

    this.EkstreHesap.BaslangicTarih = this.date
    this.EkstreHesap.BitisTarih = this.date2



    var params = this.EkstreHesap


    this.$http
      .post(auth.API_URL + "api/Abstract/ListWithFirmCartHtml", params, {
        headers: {
          Authorization: "Bearer " + auth.getAuthHeader()
        }
      }).then((response) => {
        this.progress = false
        this.load1 = true
        var blob = new Blob([response.data], {
          type: 'application/html'
        });
        var link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = "FirmaKartEkstre.html";
        link.click();
      }, (response) => {
        if (response.status === 0) {
          this.text1 = 'Service Unavailable'
          this.snackbar = true
          this.progress = false
          this.load1 = true
        } else {
          this.text1 = 'Service Unavailable'
          this.snackbar = true
          this.progress = false
          this.load1 = true
        }
      })
  }

  function getListExcel() {

    this.totalCount = 0,
      this.totalService = 0,
      this.totalAmount = 0,

      this.progress = true
    this.load1 = false


    if (this.date == null) {
      this.date = getDateNow()
    }

    if (this.date2 == null) {
      this.date2 = getDateNow()
    }


    var credentials = JSON.parse(window.localStorage.getItem('credentials'));

    if (this.tumsirketler === true) {
      this.EkstreHesap.SirketKodu = '0'
    } else {
      this.EkstreHesap.SirketKodu = credentials.SirketKodu
    }

    this.EkstreHesap.BaslangicTarih = this.date
    this.EkstreHesap.BitisTarih = this.date2



    var params = this.EkstreHesap


    this.$http
      .post(auth.API_URL + "api/Abstract/ListWithFirmCartExcel", params, {
        headers: {
          Authorization: "Bearer " + auth.getAuthHeader()
        },
        responseType: "arraybuffer"
      }).then((response) => {
        this.progress = false
        this.load1 = true
        var blob = new Blob([response.data], {
          type: 'application/xlsx'
        });
        var link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = "FirmaKartEkstre.xlsx";
        link.click();
      }, (response) => {
        if (response.status === 0) {
          this.text1 = 'Service Unavailable'
          this.snackbar = true
          this.progress = false
          this.load1 = true
        } else {
          this.text1 = 'Service Unavailable'
          this.snackbar = true
          this.progress = false
          this.load1 = true
        }
      })
  }

  function beforeMount() {

    var credentials = JSON.parse(window.localStorage.getItem('credentials'));

    var params = {
      CompanyCode: credentials.SirketKodu
    }

    this.$http.post(auth.API_URL + 'api/TicketDefinitons/AirlineList', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.itemsairlinelist = response.body
    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable'
        this.progress = false

        this.snackbar = true
      } else {
        this.text1 = 'Service Unavailable'
        this.progress = false

        this.snackbar = true
      }
    })
  }
</script>
<style>

</style>